import { render, staticRenderFns } from "./allClients.vue?vue&type=template&id=642f42fb&scoped=true"
import script from "./allClients.vue?vue&type=script&lang=js"
export * from "./allClients.vue?vue&type=script&lang=js"
import style0 from "./allClients.vue?vue&type=style&index=0&id=642f42fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f42fb",
  null
  
)

export default component.exports